import { Link } from "react-router-dom";
import { COMPANY_NAME, SUPPORT_EMAIL } from "@/constants/company";

const UPDATED = "October 2026";

export default function AcceptableUse() {
  return (
    <div className="max-w-[860px] mx-auto px-6 lg:px-10 pt-28 pb-24">
      <div className="text-[11px] tracking-luxe uppercase text-aura-muted mb-2">Legal</div>
      <h1 className="font-serif text-4xl tracking-tight mb-2">Acceptable use</h1>
      <p className="text-xs text-aura-muted mb-8">Last updated: {UPDATED}</p>

      <p className="text-sm text-aura-muted leading-relaxed mb-4">
        This policy covers the {COMPANY_NAME} developer API, playground, and MCP server, in addition to the{" "}
        <Link to="/terms" className="link-underline">Terms of Service</Link> and{" "}
        <Link to="/privacy" className="link-underline">Privacy Policy</Link>.
      </p>

      <h2 className="font-serif text-2xl mt-10 mb-3">Allowed</h2>
      <p className="text-sm text-aura-muted leading-relaxed mb-4">
        Build shopping assistants, catalogs, and comparison tools that call the published /v1 routes
        with your own API key. Send shoppers through the tracked buy links. Stay inside the published
        rate limit and credit prices.
      </p>

      <h2 className="font-serif text-2xl mt-10 mb-3">Not allowed</h2>
      <ul className="text-sm text-aura-muted leading-relaxed mb-4 list-disc pl-5 space-y-2">
        <li>Sharing, selling, or embedding a secret key in a public client.</li>
        <li>Using the API to attack, scan, or fetch internal, loopback, or metadata addresses.</li>
        <li>Bypassing rate limits, robots rules, or access controls on a marketplace.</li>
        <li>Reselling raw responses as a competing data feed without a written agreement.</li>
        <li>Submitting another person’s credentials or payment details.</li>
      </ul>

      <h2 className="font-serif text-2xl mt-10 mb-3">Enforcement</h2>
      <p className="text-sm text-aura-muted leading-relaxed mb-4">
        We may throttle, revoke a key, or close an account that breaks this policy. Questions: {SUPPORT_EMAIL}.
      </p>
    </div>
  );
}
